export const ITEM_TYPES_DND = {
  ROADMAP_COLUM_BOX: 'roadmapColumnBox',
};
